export const clinics = [
  {
    "nombre": "Clínica Santa Isabel",
    "id": 1.00,
    "mail": "atencioncliente@santaisabel.com.ar",
    "codigoEmpresa": 387124,
    "codigoEmpresaGol": 387124,
    "direccion": "Lautaro 369 / Av. Directorio 1967 (recibirá la dirección en el mail de confirmación de turno)"
  },
  {
    "nombre": "Clínica Bazterrica",
    "id": 2.00,
    "mail": "CalidadBZ@bazterrica.com.ar",
    "codigoEmpresa": 387122,
    "codigoEmpresaGol": 387122,
    "direccion": "Billinghurst y Juncal"
  },
  {
    "nombre": "Clínica del Sol",
    "id": 3.00,
    "mail": "atencionalcliente@cdelsol.com.ar",
    "codigoEmpresa": 387125,
    "codigoEmpresaGol": 387125,
    "direccion": "Av. Cnel. Díaz 2211"
  },
  {
    "nombre": "Centro Médico Bazterrica",
    "id": 4.00,
    "mail": null,
    "codigoEmpresa": 387126,
    "codigoEmpresaGol": null,
    "direccion": "Tte.Gral. J.D. Perón 1739"
  },
  {
    "nombre": "Centro Médico Santa Rita",
    "id": 5.00,
    "mail": "consultas@santaritamedicina.com.ar",
    "codigoEmpresa": 4991063,
    "codigoEmpresaGol": 4991063,
    "direccion": "Av. Blanco Encalada 158, San Isidro"
  }
]